import { domScheduler } from "@studiometa/js-toolkit/utils";
import { fallbackStore as store } from "../utils/storage/index.js";
const layouts = /* @__PURE__ */ new Set(["top", "right", "bottom", "left"]);
const defaultLayout = "top";
const callbacks = [];
function getLayout() {
  return store.get("layout") || defaultLayout;
}
function layoutIs(position) {
  return getLayout() === position;
}
function layoutIsVertical() {
  const layout = getLayout();
  return layout === "left" || layout === "right";
}
function layoutIsHoritontal() {
  const layout = getLayout();
  return layout === "top" || layout === "bottom";
}
function layoutUpdateDOM(value = getLayout()) {
  domScheduler.write(() => {
    document.documentElement.classList.toggle("is-top", value === "top");
    document.documentElement.classList.toggle("is-right", value === "right");
    document.documentElement.classList.toggle("is-bottom", value === "bottom");
    document.documentElement.classList.toggle("is-left", value === "left");
  });
}
function setLayout(value = getLayout()) {
  if (!layouts.has(value)) {
    console.log(`The "${value}" layout is not valid.`);
    value = defaultLayout;
  }
  store.set("layout", value);
  layoutUpdateDOM(value);
  callbacks.forEach((callback) => callback(value));
}
function watchLayout(callback) {
  const index = callbacks.length;
  callbacks.push(callback);
  return () => {
    callbacks.splice(index, 1);
  };
}
export {
  getLayout,
  layoutIs,
  layoutIsHoritontal,
  layoutIsVertical,
  layoutUpdateDOM,
  setLayout,
  watchLayout
};
//# sourceMappingURL=layout.js.map
